import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import notification from "@app/services/notification";
import { boApi } from "@src/api/bo";

/** Переменные выполнения BO-операции на backend. */
export interface PerformBoOperationVariables {
    operationCode: number;
    boCode: number;
}

/** Параметры {@link usePerformBoOperationMutation}. */
export interface UsePerformBoOperationMutationParams {
    /** Идентификатор экрана для `mutationKey` и `meta.errorSource`, напр. `wsLimitCard`. */
    scope: string;
    /** Синхронизация данных экрана после успешной операции. */
    onSuccess?: () => void;
}

/**
 * TanStack mutation для выполнения BO-операции через `boApi.operations.perform`.
 * @param scope префикс экрана для диагностики мутации
 * @param onSuccess колбэк синхронизации после успешного выполнения
 */
export function usePerformBoOperationMutation({
    scope,
    onSuccess,
}: UsePerformBoOperationMutationParams): UseMutationResult<void, Error, PerformBoOperationVariables> {
    return useMutation({
        mutationKey: ["workshop", scope, "bo", "perform"],
        meta: { errorSource: `workshop.${scope}.bo.perform` },
        mutationFn: ({ operationCode, boCode }: PerformBoOperationVariables) =>
            boApi.operations.perform(operationCode, boCode),
        onSuccess: () => {
            notification.success("Операция выполнена");
            onSuccess?.();
        },
    });
}
